import merge from 'merge';
import stateData from 'vue-tables-2/compiled/state/data';
import vuex from 'vue-tables-2/compiled/state/vuex';
import normal from 'vue-tables-2/compiled/state/normal';
import Table from 'vue-tables-2/compiled/table';
import { Pagination } from 'vue-pagination-2';
import reportMixins from './mixins/report';
import rowClickMixins from './mixins/row-click';
import getQueryParams from './methods/get-query-parameters';

var data = require('vue-tables-2/compiled/mixins/data');
var created = require('vue-tables-2/compiled/mixins/created');

var templateCompiler = require('vue-tables-2/compiled/template-compiler');

exports.install = function(
    Vue,
    globalOptions,
    useVuex,
    theme = 'bootstrap3',
    template = 'default',
) {
    let state = useVuex ? vuex('server') : normal();

    var server = merge.recursive(
        true,
        Table(),
        {
            mixins: [reportMixins, rowClickMixins],
            name: 'server-table',
            components: {
                Pagination,
            },
            render: templateCompiler.call(this, template, theme),
            props: {
                columns: {
                    type: Array,
                    required: true,
                },
                url: {
                    type: String,
                    required: true,
                },
                name: {
                    type: String,
                    required: false,
                },
                options: {
                    type: Object,
                    required: false,
                    default: function() {
                        return {};
                    },
                },
            },
            created: function() {
                created(this);

                if (!this.vuex) {
                    this.query = this.initQuery();
                    this.initOrderBy();
                    this.customQueries = this.initCustomFilters();
                }

                this.loadState();
                this.registerCheckboxModule();

                // listen to report filter changes
                if (this.options.useReportFilter) {
                    this.initReportCustomFilters();
                    this.registerReportFilterEvent();
                }

                this.getData(true).then(
                    function(response) {
                        this.setData(response);

                        this.loading = false;

                        if (this.hasDateFilters()) {
                            setTimeout(
                                function() {
                                    this.initDateFilters();
                                }.bind(this),
                                0,
                            );
                        }
                    }.bind(this),
                );
            },
            mounted: function() {
                if (this.vuex) return;

                this.registerServerFilters();

                if (this.options.initialPage)
                    this.setPage(this.options.initialPage, true);
            },
            data: function() {
                return merge.recursive(
                    data(),
                    {
                        source: 'server',
                        loading: true,
                        lastKeyStrokeAt: false,
                        globalOptions,
                    },
                    stateData(useVuex, 'server', this.options.initialPage),
                );
            },
            methods: {
                refresh: require('vue-tables-2/compiled/methods/refresh'),
                getData: require('vue-tables-2/compiled/methods/get-data'),
                setData: require('vue-tables-2/compiled/methods/set-data'),
                serverSearch: require('vue-tables-2/compiled/methods/server-search'),
                registerServerFilters: require('vue-tables-2/compiled/methods/register-server-filters'),
                loadState() {
                    if (!this.opts.saveState) return;

                    if (!this.storage.getItem(this.stateKey)) {
                        this.initState();
                        this.activeState = true;
                        return;
                    }

                    var state = JSON.parse(this.storage.getItem(this.stateKey));

                    if (this.vuex) {
                        this.commit('SET_STATE', {
                            query: state.query,
                            customQueries: state.customQueries,
                            page: state.page,
                            limit: state.perPage,
                            orderBy: state.orderBy,
                        });
                    } else {
                        this.page = state.page;
                        this.query = state.query;
                        this.customQueries = state.customQueries;
                        this.limit = state.perPage;
                        this.orderBy = state.orderBy;
                    }

                    if (!this.opts.pagination.dropdown) {
                        setTimeout(() => {
                            this.$refs.pagination.Page = state.page;
                        }, 0);
                    }

                    this.activeState = true;
                },
                registerCheckboxModule: require('./methods/register-checkbox-module'),
                getQueryParams: getQueryParams,
            },
            computed: {
                hasCheckboxSelected: require('./computed/has-checkbox-selected'),
                totalPages: require('vue-tables-2/compiled/computed/total-pages'),
                filteredQuery: require('vue-tables-2/compiled/computed/filtered-query'),
                hasMultiSort() {
                    return this.opts.serverMultiSorting;
                },
            },
        },
        state,
    );

    Vue.component('v-server-table', server);

    return server;
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/v-server-table.js